// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2930r","amount":"Amount_amount__1xuQR","tip":"Amount_tip__3238e","tipHeader":"Amount_tipHeader__2bj4l","tipsWrap":"Amount_tipsWrap__fIauC"};